<template lang="pug">
  v-card
    v-card-title
      h2.modal-title {{ 'base.create' | translate }}
    v-card-content
      v-input(
        :label="$t('base.name')"
        :hint="errorMessage('name')"
        :invalid="!!errorMessage('name')"
        v-model="payload.name")   
      v-select(
        :label="$t('base.type')"
        item-text="name"
        item-value="id"
        :options="deliveryTypes"
        v-model="payload.side")
      v-input(
        :label="$t('base.information')"
        v-model="payload.description")
      v-input-r(
        :label="$t('base.edrpu')"
        :hint="errorMessage('ind_code')"
        :invalid="!!errorMessage('ind_code')"
        v-model="payload.ind_code")
    v-card-actions
      v-btn(
        :disabled="!isFormFilled"
        :loading="loading"
        @click="onCompanyCreate")
        | {{ 'base.add' | translate }}
</template>

<script>
import { mapActions } from 'vuex'
import api from '@/api'
import formErrorsMixin from '@/mixins/form-errors.mixin.js'
export default {
  name: 'CreateModal',

  data: () => ({
    payload: {
      name: null,
      side: 'seller',
      ind_code: null,
      description: null
    },
    errors: {
      name: null,
      ind_code: null
    },
    deliveryTypes: [
      { id: 'seller', name: 'base.seller' },
      { id: 'buyer', name: 'base.buyer' }
    ],
    loading: false
  }),
  mixins: [formErrorsMixin],
  methods: {
    ...mapActions('deliveries', [
      'createCompany'
    ]),

    async onCompanyCreate () {
      this.loading = true
      const payload = {
        farm: this.$route.params.farm_id,
        ...this.payload
      }

      this.checkValidData()

      if (this.errors.name === null && this.errors.ind_code === null) {
        const { errors } = await api.deliveries.companies.create(payload)
        this.errors = errors
        if (!errors) {
          await this.createCompany(payload)
          this.$emit('close')
        }
      }
      this.loading = false
    },
    checkValidData () {
      this.errors.name = null
      this.errors.ind_code = null

      const isUS = this.$store.getters['account/lang'] === 'us'

      // Validate name
      if (!this.payload.name) {
        this.errors.name = ['3']
      } else if (this.payload.name.length > 100) {
        this.errors.name = ['6', 100]
      }

      // Validate ind_code depending on locale
      if (!this.payload.ind_code || this.payload.ind_code.length === 0) {
        this.errors.ind_code = ['3']
      } else if (isUS) {
        // US: must be exactly 9 digits
        if (!/^\d{9}$/.test(this.payload.ind_code)) {
          this.errors.ind_code = ['6', 9]
        }
      } else {
        // Other: must be 8 to 12 digits
        if (!/^\d{8,12}$/.test(this.payload.ind_code)) {
          this.errors.ind_code = ['6', 12]
        } else if (this.payload.ind_code.length < 8 || this.payload.ind_code.length > 12) {
          this.errors.ind_code = ['6', 12]
        }
      }
    },
  },

  computed: {
    isFormFilled () {
      return !!this.payload.name && !!this.payload.ind_code
    }
  }
}
</script>
<style scoped>
.v-card__title {
  padding: 2rem 2.4rem 1.6rem;
}

.modal-title {
  font-size: 2rem;
  font-weight: 700;
  margin: 0;
}

.v-card__content {
  border-top: .1rem solid #d7d7d7;
  padding-bottom: 1.5rem !important;
}

.v-card__actions {
  padding: 0 2.4rem 2.4rem;
}

.v-card__actions button {
  width: 100%;
}
</style>
